import axios from 'axios';
export default {
    send: function send(options) {
        axios.post(options.url, options.data).then(function (response) {
            var data = response.data;
            if (!data || data.code !== 200) {
                options.error && options.error(data && data.msg);
                return;
            }
            options.success && options.success(data);
        })['catch'](function (e) {
            console.error(e);
            options.error && options.error();
        });
    },
    read: function read(options) {
        axios.get(options.url).then(function (response) {
            var data = response.data;
            if (!data || data.code !== 200) {
                options.error && options.error(data && data.msg);
                return;
            }
            options.success && options.success(data.result.data.map(function (item) {
                return {
                    time: item.offset_time,
                    type: item.type || 'top',
                    color: item.color || '#fff',
                    author: item.author || '',
                    text: item.content || ''
                };
            }));
        })['catch'](function (e) {
            console.error(e);
            options.error && options.error();
        });
    }
};